export const ymapFilter = (btnSelector, parentSelector) => {
    try {
        let btn = document.querySelector(btnSelector);
        let parent = document.querySelector(parentSelector);

        btn.addEventListener('click', () => {
            parent.classList.toggle('js-active');
        })


    } catch (e) { }
}